export const contentConfig = [
  {
    link: 'course',
    icon: 'calss',
    tip: {
      chinese: '课程管理',
      english: 'content',
    },
    uuid: 'COURSE',
    params: [
      {
        key: 'subject',
        required: 'true',
        default: 'chinese',
        type: 'query',
      },
      { key: 'course', required: 'optional' },
      { key: 'businessConfigUuid', required: 'optional' },
      {
        key: 'item',
        required: 'optional',
        default: 'catalog',
        type: 'query',
      },
      { key: 'itemName', required: 'optional', type: 'query' },
      {
        key: 'level',
        type: 'query',
      },
      {
        key: 'index',
        type: 'query',
      },
    ],
  },
  {
    link: 'contentLibrary',
    icon: 'ques',
    tip: {
      chinese: '题库',
      english: 'content library',
    },
    uuid: 'CONTENT_REPOSITORY',
  },
  {
    link: 'content',
    icon: 'resources',
    tip: {
      chinese: '专辑资源',
      english: 'content',
    },
    uuid: 'ALBUM',
    sub: [
      {
        link: 'independentBusiness',
        icon: 'book',
        tip: {
          chinese: '非课程应用',
          english: 'independent business',
        },
        uuid: 'INDEPENDENT_BUSINESS',
        params: [{ key: 'businessConfigUuid', required: 'optional' }],
      },
      {
        link: 'albums',
        params: [{ key: 'albumUuid', required: 'optional' }],
        tip: {
          chinese: '专辑',
          english: 'album',
        },
      },
    ],
  },
];
